import http from '../../services/config/config';
// const FormData = require('form-data')
import router from "../../router";

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  access_token: getSavedState("auth.access_token"),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
  },
  SET_ACCESS_TOKEN(state, newValue) {
    state.access_token = newValue;
    saveState("auth.access_token", newValue);
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  getUser: (state) => state.currentUser,
  getAccessToken: (state) => state.access_token,
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch("setDefaultAuthHeaders")
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { login, senha } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return  http.post('/auth/login', { login, senha }).then((response) => {
      if (response.data.dados.user) {
        commit("SET_CURRENT_USER", response.data.dados.user);
        commit("SET_ACCESS_TOKEN", response.data.dados.access_token);
        dispatch("setDefaultAuthHeaders");
        router.push("/")
      } else {
        commit("SET_CURRENT_USER", null);
        commit("SET_ACCESS_TOKEN", null);
        dispatch("setDefaultAuthHeaders");
      }
      return response;
    })
  },

  // Logs out the current user.
  logOut({ commit, dispatch }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_ACCESS_TOKEN', null)
    dispatch("setDefaultAuthHeaders");
    router.push("/login");
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    if(state.currentUser != null){
      commit('SET_CURRENT_USER', state.currentUser)
      return state.currentUser
    }
    
  },

  setDefaultAuthHeaders({ getters }) {
    if (getters.getAccessToken) {
      http.defaults.headers.authorization = "Bearer " + getters.getAccessToken
    }
    else{
      delete http.defaults.headers.Authorization;
    }
  }
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
